import { useBalanceStore } from '@/store/balanceStore'

export const useBalance = useBalanceStore
